<template>
  <b-container
    class="mb-5"
    fluid
  >
    <DashboardComponent />
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import DashboardComponent from '@/components/dashboard/Dashboard.component'

export default {
  name: 'MarketingOfficerDashboard',
  components: {
    DashboardComponent
  },
  middleware: ['auth', 'marketing-officer'],
  metaInfo () {
    return {
      title: 'Marketing Officer Dashboard'
    }
  },
  mounted () {
    core.index()
  }
}
</script>
